import Swiper, { Autoplay } from 'swiper';
import SwiperCore, { Scrollbar } from 'swiper/core';
import 'swiper/css';
import 'swiper/css/autoplay';
SwiperCore.use([Autoplay, Scrollbar]);

export default class HeroUspCarousel {
    /**
        * Class constructor *
        * @arg {object} - `sliderElement` check for the
        * hero usp carousel element.
    **/
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.init()
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 1.5,
            spaceBetween: 20,
            threshold: 10,
            speed: 400,
            autoplay: {
                delay: 3000,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                1280: {
                    slidesPerView: 4,
                    spaceBetween: 0
                }
            }
        });
    }
}
